<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0"
          ></v-breadcrumbs>
    
          <h1 class="primary--text">
              <v-row>
                <v-col cols="12" md="3">                  
                  <v-icon color="primary">mdi-currency-eur</v-icon> <span>Despesas</span>
                </v-col>
                <v-col cols="12" md="9" align="end">
                  <v-btn @click="$router.push('/despesas/create')" rounded class="success">
                    <v-icon class="mr-2">mdi-plus</v-icon>Despesa
                  </v-btn>
                </v-col>
              </v-row>
          </h1>
          
          <div style="position:relative">
            <v-container>
            </v-container>
    
            <v-data-table
              :headers="headers"
              :items="items"
              :server-items-length="total"
              :loading="loading"
              :footer-props="tableFooter"
              :options.sync="options"
              class="mt-16"
              locale="pt-pt"
            >
                <template v-slot:item.actions="{item}">
                  <v-btn  class="success" @click="$router.push('/despesas/' + item.id)">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
              
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </section>
  </template>
  <script>
  import dayjs from 'dayjs';
  import Despesas from "@/api/Despesas.js";
  
  export default {
    components: {
    },
    watch: {
      'options': {
        immediate: false,
        handler () {
          setTimeout(() => {this.searchDespesas()}, 10);
        },
        deep: true,
      },
    },
    beforeCreate(){
      document.title = "ODC - Despesas";
    },
    data: () => ({      
      headers: [
        {
          text: 'Nº Fatura',
          sortable: true,
          value: 'n_fatura',
        },
        {
          text: 'Data',
          sortable: true,
          value: 'data_fatura',
        },
        {
          text: 'Valor (€)',
          sortable: true,
          value: 'valor_fatura',
        },
        {
          text: 'Estado',
          sortable: true,
          value: 'status',
        },
        {
          text: '',
          sortable: true,
          value: 'actions',
        }
      ],
      items: [],
      total: 0,
      loading: false,
      searching: false,
      tableFooter: {
        'items-per-page-options': [5, 10, 15, 20],
        'items-per-page-text': "Linhas por página"
      },
      options: {},
      speedDial:false,
      filter: {
      },
    }),
    mounted(){
  
      if(!this.$store.getters.hasPermission(["super", "expenses.read"])) {
        this.$router.push('/admin');
      }
  
      this.fillBaseData();
    },
    methods:{      
      fillBaseData() {
  
        if(localStorage["expenses-list-" + this.$store.state.user.data.id] != undefined){
  
          let data = JSON.parse(localStorage["expenses-list-" + this.$store.state.user.data.id]);
  
          this.filter = data.filter;
  
          this.options = data.options;
        }
      },
      searchDespesas(event){
        if(!!event && event.type == 'submit'){
          this.options.page = 1;
        }
  
        this.loading = true;
  
        let filter = {...this.filter};
  
        let request = {
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          page: this.options.page,
          limit: this.options.itemsPerPage,
        };
      
        Object.assign(request, filter);
  
        localStorage["expenses-list-" + this.$store.state.user.data.id] = JSON.stringify({
          filter: this.filter,
          options: this.options,
        });
  
        Despesas.search(request).then(response => {
  
          let data = response.data;
  
          this.total = data.total;
  
          this.items = data.data.map((item) => {
  
            this.searching = false;
  
            return item;
          });
  
          this.loading = false;
  
        });
      },
      resetDespesas()
      {
        this.filter = {
        };
  
        this.searchDespesas();
      },
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Despesas',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  